import axios from 'axios'

import config from '../../config'

const createSafetyItemResponse = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/SafetyItemResponses`
  return axios.post(url, data)
}

export default createSafetyItemResponse
